import(/* webpackMode: "eager" */ "/vercel/path0/app/(app)/error.tsx");
